import { enviaMsgSucesso } from "../helpers/Notificacoes";
import api from "../config/api";
import { tratarErroRequisicao } from "../helpers/Errors";

const { REACT_APP_BASE_URL } = process.env || "";

export class IndicadoresGraficosService {
    private readonly baseUrl: string;
    private readonly onUnauthorized?: () => void;

    constructor(onUnauthorized?: () => void) {
        this.baseUrl = REACT_APP_BASE_URL!;
        this.onUnauthorized = onUnauthorized;
    }

    async get(path: string, options: RequestInit = {}) {
        try {
            const customHeaders = options.headers ? (options.headers as Record<string, any>) : {};

            const response = await api.get(path, {
                headers: { ...customHeaders },
                signal: options.signal || this.createTimeoutSignal(10000),
            });

            return enviaMsgSucesso(200, "Busca Indicadores", response.data);

        } catch (error: any) {
            return tratarErroRequisicao(error, path, this.onUnauthorized);
        }
    }

    private createTimeoutSignal(timeout: number): AbortSignal | undefined {
        const controller = new AbortController();
        setTimeout(() => controller.abort(), timeout);
        return controller.signal;
    }
}